import React, { Component } from 'react';
import UserProfile from './UserProfile';

class Navbar extends Component {

  componentDidMount() {
    // Start of edebebrasil Zendesk Widget script
    // const script = document.createElement("script");
    // script.id = "ze-snippet";
    // script.src = "https://static.zdassets.com/ekr/snippet.js?key=6e60cc12-9379-43b1-b174-56a45ffe6ba2";
    // script.async = true;
    // script.onload = () => this.scriptLoaded();

    // document.body.appendChild(script);
    // End of edebebrasil Zendesk Widget script
  }

  // scriptLoaded() {
  //   window.zE('webWidget', 'hide');
  // }

  // showSupport() {
  //   window.zE('webWidget', 'toggle');
  // }

  render() {
    // if (this.props.profile.decodedToken) {
    //   window.zE('webWidget', 'identify', {
    //     name: this.props.profile.decodedToken.name,
    //     email: this.props.profile.decodedToken.email
    //   });
    // }
    return (
      <div className="edb-theme edb-display-container edb-top edb-select-none">

        {/* Ícone menu */}
        <i alt="menu" className="edb-button edb-hover-text-white adap-hover-red2 fas fa-bars edb-cell-middle edb-xxlarge edb-margin-left" onClick={this.props.onClickMenuIcon}></i>

        {/* Logo edebê */}
        <a href="https://edu.edebe.com.br" title="Ir para a Plataforma Edebê Edu"><img className="edb-margin" src="/images/logo-edebe.svg" alt="Edebê Educação" width="78" /></a>

        {/* Parte direita da Navbar */}
        <div className="edb-display-right edb-padding">
          <UserProfile
            className="edb-inline"
            profile={this.props.profile}
            photo={this.props.photo}
            onLogout={this.props.onLogout}
          />
          <div className="edb-inline edb-margin-left">
            {/* <img src="/images/ico-headsetbranco.svg" width="28" alt="Suporte" title="Suporte" style={{ cursor: 'pointer' }} onClick={this.showSupport} /> */}
          </div>
        </div>
      </div>
    );
  }
}

export default Navbar;